import { useState, useEffect } from "react";
import {Typography, Box} from "@mui/material";

const RealTimeClock = () => {

    const [currentTime, setCurrentTime] = useState(new Date());


    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            height="100%"
        >
            <Typography variant="h3" fontWeight="bold">
                {currentTime.toLocaleTimeString()}
            </Typography>
            <Typography variant="h5" color="textSecondary">
                {currentTime.toLocaleDateString()}
            </Typography>
        </Box>
    );
};

export default RealTimeClock;
